<div class="flex-direction-column page-redesign">
  <div class="conta-cabecalho flex-direction-row justify-between align-center wrap gap-15">
    <app-titulo-rotina
      class="conta-titulo"
      titulo="Contas"
      subtitulo="Gerencie as contas WhatsApp e Instagram cadastradas no sistema."
      [mostrarBotaoMenu]="true"
      (aoVoltar)="voltar()"
      (aoAbrirMenu)="abrirMenuMobile()">
    </app-titulo-rotina>

    <div class="conta-acoes">
      <app-search placeholder="Pesquisar número, WABA ID ou usuário..." (valorChange)="filtrarBusca($event)"></app-search>
      <div class="conta-acoes-coluna">
        <button type="button" class="conta-botao-filtro" [class.conta-botao-filtro-ativo]="temFiltrosAplicados"
                (click)="alternarPainelFiltro()">
          <img src="./assets/icones/redesign/filter/filter-icon.svg" alt="" />
          <span>Filtros</span>
          <img class="conta-botao-filtro-chevron" alt=""
            [src]="painelFiltroAberto ? './assets/icones/redesign/utils/chevron-top.svg' : './assets/icones/redesign/utils/chevron-bottom.svg'" />
        </button>
        <app-botao class="conta-botao-novo" label="Nova Conta" (aoClicar)="abrirModal(false)"></app-botao>
      </div>
    </div>
  </div>

  <app-filtro-painel [formGroup]="filtroForm" [aberto]="painelFiltroAberto" [tags]="tagsFiltros"
    (removerTag)="removerFiltro($event)">
    <app-campo-select label="Origem" [lista]="opcoesCanal" campo="nome" placeholder="Todos"
      [multiplo]="true" formControlName="canal"></app-campo-select>
    <app-campo-select label="Setor" [lista]="setoresComTodos" campo="nome" placeholder="Todos"
      [habilitarBusca]="true" [multiplo]="true" formControlName="setor"></app-campo-select>
    <app-campo-select label="Fluxo" [lista]="fluxosComTodos" campo="nome" placeholder="Todos"
      [habilitarBusca]="true" [multiplo]="true" formControlName="fluxo"></app-campo-select>
    <app-campo-data label="Data Criação" formControlName="dataCriacao"></app-campo-data>
    <app-campo-data label="Data Alteração" formControlName="dataAlteracao"></app-campo-data>
    <app-campo-select label="Usuário Criação" [lista]="usuarios" campo="nome" placeholder="Todos"
      [habilitarBusca]="true" formControlName="usuarioCriacao"></app-campo-select>
    <app-campo-select label="Usuário Alteração" [lista]="usuarios" campo="nome" placeholder="Todos"
      [habilitarBusca]="true" formControlName="usuarioAlteracao"></app-campo-select>
  </app-filtro-painel>

  <app-filtros-tab
    class="conta-filtros"
    [abas]="abasFiltro"
    [abaAtiva]="abaAtiva"
    (aoSelecionar)="selecionarAba($any($event))">
  </app-filtros-tab>

  @if (carregando) {
    <app-tabela class="conta-vista-desktop" [carregando]="true" [colunasSkeleton]="7" [linhasSkeleton]="5"></app-tabela>

    <div class="conta-vista-mobile conta-cards-mobile flex-direction-column">
      @for (i of [1, 2, 3]; track i) {
        <div class="conta-card-mobile-skeleton skeleton"></div>
      }
    </div>
  } @else if (contas.length > 0) {
    <app-tabela class="conta-vista-desktop">
      <mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="gutterInicio">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let elemento"></mat-cell>
        </ng-container>

        <ng-container matColumnDef="acao">
          <mat-header-cell *matHeaderCellDef>Ações</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            <app-tabela-acao [isMenu]="true" icone="./assets/icones/redesign/table/more-options.svg"
              titulo="Mais ações" [itensMenu]="itensAcao(elemento)"></app-tabela-acao>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nome">
          <mat-header-cell *matHeaderCellDef>Nome</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            <div class="flex-direction-row align-center gap-8">
              <img [src]="logoCanal(elemento)" alt="" class="conta-tabela-logo" />
              <div class="flex-direction-column conta-tabela-nome-coluna">
                <span [matTooltip]="elemento.nome" class="ellipse conta-tabela-nome">{{ elemento.nome }}</span>
                <span class="conta-tabela-canal"
                  [class.conta-tabela-canal-whatsapp]="elemento.canalOrigem !== CanalOrigemContatoEnum.INSTAGRAM"
                  [class.conta-tabela-canal-instagram]="elemento.canalOrigem === CanalOrigemContatoEnum.INSTAGRAM">
                  {{ nomeCanal(elemento) }}
                </span>
              </div>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numero">
          <mat-header-cell *matHeaderCellDef>Número</mat-header-cell>
          <mat-cell *matCellDef="let elemento">{{ elemento.canalOrigem === CanalOrigemContatoEnum.INSTAGRAM ? elemento.numero : (elemento.numero | celularMask) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="wabaOuIgId">
          <mat-header-cell *matHeaderCellDef>
            <span>WABA ID / IG ID</span>
            <img class="conta-icone-info" src="./assets/icones/redesign/utils/info-field.svg" alt=""
              matTooltip="WABA ID para contas do WhatsApp, ou o ID da conta profissional do Instagram." />
          </mat-header-cell>
          <mat-cell *matCellDef="let elemento" [matTooltip]="wabaOuIgId(elemento)">{{ wabaOuIgId(elemento) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="metaId">
          <mat-header-cell *matHeaderCellDef>
            <span>META ID</span>
            <img class="conta-icone-info" src="./assets/icones/redesign/utils/info-field.svg" alt=""
              matTooltip="ID do aplicativo/página cadastrado na Meta associado a esta conta." />
          </mat-header-cell>
          <mat-cell *matCellDef="let elemento" [matTooltip]="elemento.numeroMetaId">{{ elemento.numeroMetaId || '--' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="aplicativoId">
          <mat-header-cell *matHeaderCellDef>ID Aplicativo</mat-header-cell>
          <mat-cell *matCellDef="let elemento" [matTooltip]="elemento.aplicativoId">{{ elemento.aplicativoId || '--' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="setor">
          <mat-header-cell *matHeaderCellDef>Setor</mat-header-cell>
          <mat-cell *matCellDef="let elemento" [matTooltip]="setoresNomes(elemento.setor)" class="ellipse">{{ setoresNomes(elemento.setor) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="fluxo">
          <mat-header-cell *matHeaderCellDef>Fluxo</mat-header-cell>
          <mat-cell *matCellDef="let elemento" [matTooltip]="elemento.fluxo?.nome" class="ellipse">{{ elemento.fluxo?.nome || '--' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
          <mat-cell *matCellDef="let elemento">
            <span class="badge-status" [class.badge-status-concluido]="elemento.ativo" [class.badge-status-erro]="!elemento.ativo">
              <span class="bolinha-status" [class.status-concluido]="elemento.ativo" [class.status-erro]="!elemento.ativo"></span>
              {{ elemento.ativo ? 'Ativo' : 'Inativo' }}
            </span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="gutterFim">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let elemento"></mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </app-tabela>

    <app-paginador
      class="conta-vista-desktop"
      [length]="length"
      [pageSize]="limit"
      [pageIndex]="page"
      [pageSizeOptions]="pageSizeOptions"
      (pageChange)="handlePageEvent($event)">
    </app-paginador>

    <div class="conta-vista-mobile conta-cards-mobile flex-direction-column">
      @for (elemento of contas; track elemento.id) {
        <div class="conta-card-mobile" (click)="abrirModal(true, elemento)">
          <div class="conta-card-mobile-topo">
            <img [src]="logoCanal(elemento)" alt="" class="conta-card-mobile-logo" />
            <div class="flex-direction-column gap-5 conta-card-mobile-info">
              <div class="conta-card-mobile-titulo-linha">
                <span class="conta-card-mobile-titulo" [matTooltip]="elemento.nome">{{ elemento.nome }}</span>
                <span class="badge-status conta-card-mobile-status" [class.badge-status-concluido]="elemento.ativo" [class.badge-status-erro]="!elemento.ativo">
                  <span class="bolinha-status" [class.status-concluido]="elemento.ativo" [class.status-erro]="!elemento.ativo"></span>
                  {{ elemento.ativo ? 'Ativo' : 'Inativo' }}
                </span>
              </div>
              <span class="conta-tabela-canal"
                [class.conta-tabela-canal-whatsapp]="elemento.canalOrigem !== CanalOrigemContatoEnum.INSTAGRAM"
                [class.conta-tabela-canal-instagram]="elemento.canalOrigem === CanalOrigemContatoEnum.INSTAGRAM">
                {{ nomeCanal(elemento) }}
              </span>
              <span class="conta-card-mobile-numero">{{ elemento.canalOrigem === CanalOrigemContatoEnum.INSTAGRAM ? elemento.numero : (elemento.numero | celularMask) }}</span>
            </div>
          </div>

          <div class="conta-card-mobile-divisor"></div>

          <div class="conta-card-mobile-rodape">
            <span class="conta-card-mobile-setor">{{ setoresNomes(elemento.setor) }}</span>
            <div class="conta-card-mobile-acoes" (click)="$event.stopPropagation()">
              <button type="button" class="conta-card-mobile-btn-icone" title="Editar" (click)="abrirModal(false, elemento)">
                <img src="./assets/icones/redesign/table/icon-edit-table.svg" alt="" />
              </button>
            </div>
          </div>
        </div>
      }
    </div>

  } @else {
    <div class="flex center-center height-100">
      <img class="conta-imagem-vazio" src="./assets/imagem-mulher-nao-eh-bug.png" alt="Nenhuma conta encontrada">
    </div>
  }

  @if (!carregando) {
    <button type="button" class="conta-fab" title="Nova Conta" (click)="abrirModal(false)">
      <img src="./assets/icones/redesign/button/icon-add-button.svg" alt="" />
    </button>
  }
</div>
